<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 8H4a2 2 0 00-2 2v4a2 2 0 002 2h1v4a1 1 0 001 1h2a1 1 0 001-1v-4h3l5 4V4l-5 4m9.5 4c0 1.71-.96 3.26-2.5 4V8c1.53.75 2.5 2.3 2.5 4z"/>
    </svg>
</template>

<script>
export default {
    name: 'BullhornIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
